<template>
  <v-col :cols="12" :sm="12" :md="12">
    <v-alert
      v-show="newNotify.isNewNotify"
      border="left"
      close-text="Close Alert"
      color="green accent-4"
      dark
      @click="newNotify.isNewNotify = false"
    >
      {{ newNotify.text }}
    </v-alert>

    <v-row>
      <v-col  cols="12">
        <v-card class="pa-md-3">
          <v-card-title class="headline">
            <v-icon color="#03B2EE" large left>
              mdi-map
            </v-icon>
            <span class="text-h6 font-weight-light">Mapa de Licenças</span>
          </v-card-title>

          <v-card-text>
            <MglMap
              :accessToken="accessToken"
              :mapStyle.sync="mapStyle"
              :zoom.sync="zoom"
              :center.sync="centerMap"
              style="width: 100%; height: 400px;"
              @load="iniciarMapa"
            >
              <MglMarker
                v-for="(endereco, i) in listaEnderecosLicencas"
                :key="i"
                :coordinates="[
                  endereco.endereco.longitude,
                  endereco.endereco.latitude,
                ]"
                :color="colorMaker"
              >
                <MglPopup>
                  <v-card>
                    <v-card-text>
                      <p>Nome da empresa: {{ endereco.empresa.nomeFantasia }}</p>
                      <p>Cevs: {{ endereco.endereco.cevs }}</p>
                      <p>Endereço: {{ endereco.endereco.endereco }}</p>
                    </v-card-text>
                  </v-card>
                </MglPopup>
              </MglMarker>
            </MglMap>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-md-3 mx-lg-auto" cols="6">
        <v-card class="pa-md-3">
          <v-card-title class="headline">
            <v-icon color="#03B2EE" large left>
              mdi-archive
            </v-icon>
            <span class="text-h6 font-weight-light">Licenças</span>
          </v-card-title>
          <v-card-text>
            <Bar
              height="100%"
              :chartData="dadosLicencas"
              :options="optionsBar"
            ></Bar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col class="pa-md-3 mx-lg-auto" cols="6">
        <v-card class="pa-md-3">
          <v-card-title class="headline">
            <v-icon color="#03B2EE" large left>
              mdi-archive
            </v-icon>
            <span class="text-h6 font-weight-light">Faturamento Anual</span>
          </v-card-title>
          <v-card-text>
            <Bar
              height="100%"
              :chartData="dadosFaturamentoAnual"
              :options="optionsBar"
            ></Bar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import { MglMap, MglPopup, MglMarker } from "vue-mapbox";
import "mapbox-gl/dist/mapbox-gl.css";
import Bar from "@/components/Charts/Bar";

let mapa = null
 
export default {
  components: {
    MglMap,
    MglPopup,
    MglMarker,
    Bar,
  },

  data() {
    return {
      accessToken: "pk.eyJ1IjoiZmVpb2t1biIsImEiOiJjanJtOWpsdzcwaDJsNDR0Mmh0ZGV1bzR2In0.XWAmqcgxDNyjq3Mg2XDE0g",
      mapStyle: "mapbox://styles/mapbox/streets-v11",
      centerMap: [-47.287163, -23.2695046],
      zoom: 16,
      colorMaker: "green",
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
      newNotify: {
        isNewNotify: false,
        text: "",
      },
      filtroMapa: {
        status: 2,
      },
      listaEnderecosLicencas: [],
      dadosLicencas: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },
      dadosFaturamentoAnual: {
        datasets: [
          {
            data: [],
            backgroundColor: [],
          },
        ],
        labels: [],
      },

      optionsBar: {
        legend: {
          display: false,
        },
        onClick: (evt, array) => {
          if (array.length != 0) {
            var posicao = array[0]._index;
            var status = array[0]._chart.tooltip._data.labels[posicao];
            this.atualizarMapaPorStatus(status);
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },

  created() {
    this.inicializar();
  },

  methods: {
    async atualizarMapaPorStatus(status) {
      this.listaEnderecosLicencas = null;

      console.log(status);

      if (status == "Em Vigência") {
        this.filtroMapa.status = 2;
        this.colorMaker = "green";
      }
      if (status == "Próximas a Vencer") {
        this.filtroMapa.status = 0;
        this.colorMaker = "orange";
      }
      if (status == "Vencidas") {
        this.filtroMapa.status = 1;
        this.colorMaker = "red";
      }
      await this.listarEnderecos();
    },

    async iniciarMapa(map) {
      mapa = map.map;
      const enderecoLicenca = await axios.put(
        "/listarEnderecoPorLicenca",
        this.filtroMapa,
        this.config
      );
      this.listaEnderecosLicencas = enderecoLicenca.data;
      await this.centralizarMapa(
        this.listaEnderecosLicencas[this.listaEnderecosLicencas.length - 1]
          .endereco.longitude,
        this.listaEnderecosLicencas[this.listaEnderecosLicencas.length - 1]
          .endereco.latitude
      );
    },

    async listarEnderecos() {
      const enderecoLicenca = await axios.put(
        "/listarEnderecoPorLicenca",
        this.filtroMapa,
        this.config
      );
      this.listaEnderecosLicencas = enderecoLicenca.data;

      await this.centralizarMapa(
        this.listaEnderecosLicencas[this.listaEnderecosLicencas.length - 1]
          .endereco.longitude,
        this.listaEnderecosLicencas[this.listaEnderecosLicencas.length - 1]
          .endereco.latitude
      );
    },

    async centralizarMapa(longitude, latitude) {
      mapa.flyTo({
        style: "mapbox://styles/mapbox/streets-v11",
        center: [longitude, latitude],
      });
    },

    async inicializar() {
      const graficoLicensaStatus = await axios.get(
        "/graficoLicencaPorStatus",
        this.config
      );
      this.dadosLicencas = graficoLicensaStatus.data;
      const graficoFaturamentoAnual = await axios.get(
        "/graficoFaturamentoAnual",
        this.config
      );
      this.dadosFaturamentoAnual = graficoFaturamentoAnual.data;
    },
  },
};
</script>
